import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { DashboardCard } from '../../../../interfaces/strapi';

@Component({
    selector: 'app-protect-and-save-carousel-slide',
    templateUrl: './protect-and-save-carousel-slide.component.html',
    styleUrls: ['./protect-and-save-carousel-slide.component.scss'],
    imports: [NgIf],
})
export class ProtectAndSaveCarouselSlideComponent {
  @Input() public slide: DashboardCard | undefined;
}
